import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedRoutingModule } from './shared-routing.module';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { LoadingTransparentComponent } from './components/loading-transparent/loading-transparent.component';


@NgModule({
  declarations: [
    SpinnerComponent,
    LoadingTransparentComponent
  ],
  imports: [
    CommonModule,
    SharedRoutingModule
  ],
  exports: [
    SpinnerComponent,
    LoadingTransparentComponent
  ]
})
export class SharedModule { }
